export default "__VITE_PUBLIC_ASSET__ba31d965__"